












import { Component, Mixins, Prop } from "vue-property-decorator";
import { RichTextBoxInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import { RichTextBoxInputMethodOptionKinds } from "../../../../domain/document/inputMethodOptionKinds";
import RichTextBoxObject from "../objects/RichTextBoxObject.vue";
import InputMethodSelector from "./InputMethodSelector.vue";
import Enumerable from "linq";

@Component({
  components: {
    InputMethodSelector,
  }
})
export default class RichTextBoxInputMethodSelector extends Mixins() {
  @Prop()
  source: RichTextBoxObject;

  @Prop({ default: true })
  isUnselectionEnable: boolean;

  get optionSet(): RichTextBoxInputMethodKinds[] {
    if (this.source.isEditDisabledByRuleSet) {
      return [];
    }
    const kinds = this.optionSets[this.source.inputMethodOptionKind];
    return this.source.isFreeInputable
      ? kinds
      : Enumerable.from(kinds).where(k => k !== RichTextBoxInputMethodKinds.FreeInput).toArray();
  }

  get unselection(): RichTextBoxInputMethodKinds {
    return this.isUnselectionEnable
      ? this.unselectionSets[this.source.inputMethodOptionKind]
      : null;
  }

  displayTexts: { key: RichTextBoxInputMethodKinds, text: string }[] = [
    { key: RichTextBoxInputMethodKinds.None, text: "入力不可" },
    { key: RichTextBoxInputMethodKinds.FreeInput, text: "フリー入力" },
    { key: RichTextBoxInputMethodKinds.MKSTemplate, text: "MKSテンプレート" },
    { key: RichTextBoxInputMethodKinds.DynamicTemplate, text: "ダイナミックテンプレート" },
  ];

  private optionSets: { [key in RichTextBoxInputMethodOptionKinds]: RichTextBoxInputMethodKinds[] } = {
    Normal: [], // 常にフリー入力なので切り替えない
    MKSTemplate: [ RichTextBoxInputMethodKinds.FreeInput, RichTextBoxInputMethodKinds.MKSTemplate ],
    DynamicTemplate: [ RichTextBoxInputMethodKinds.FreeInput, RichTextBoxInputMethodKinds.DynamicTemplate ],
  };

  private unselectionSets: { [key in RichTextBoxInputMethodOptionKinds]: RichTextBoxInputMethodKinds } = {
    Normal: null,
    MKSTemplate: null,
    DynamicTemplate: null,
  };
}
